import { useState, useEffect } from "react";
import api from "../lib/api";

// Paginación server-side reutilizable: maneja page/q/fechas/estado y refetch con debounce.
export function usePaged(endpoint, { pageSize = 50, extraParams = {} } = {}) {
  const extraKey = JSON.stringify(extraParams);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [page, setPage] = useState(1);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [status, setStatus] = useState("all");
  const [loading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);
  const reload = () => setTick((t) => t + 1);

  useEffect(() => { setPage(1); }, [q, from, to, status, extraKey]);

  useEffect(() => {
    let cancel = false;
    setLoading(true);
    const h = setTimeout(() => {
      api
        .get(endpoint, { params: { page, page_size: pageSize, q, date_from: from, date_to: to, status: status === "all" ? "" : status, ...extraParams } })
        .then((r) => { if (!cancel) { setItems(r.data.items || []); setTotal(r.data.total || 0); setPages(r.data.pages || 1); } })
        .catch(() => {})
        .finally(() => { if (!cancel) setLoading(false); });
    }, 300);
    return () => { cancel = true; clearTimeout(h); };
  }, [endpoint, page, pageSize, q, from, to, status, tick, extraKey]);

  const clear = () => { setQ(""); setFrom(""); setTo(""); setStatus("all"); };
  return { rows: items, total, pages, page, setPage, q, setQ, from, setFrom, to, setTo, status, setStatus, loading, reload, clear };
}

export default usePaged;
